import * as React from 'react';
// import Stores from '../components/Stores';
import { Title, Section, Container, Button } from '../modules/modules';
import { ForgottenPw as ForgottenPwForm } from '../components/Query/User';

class ForgottenPw extends React.Component {
  public render() {
    return (
      <main>
        <Section type="forgottenPw">
          <Container>
            <Title type="textPage">
              Forgotten password
            </Title>
            <div className="row">
              <div className="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-4">
                <div className="forgottenPw__block">
                  <ForgottenPwForm />
                </div>
              </div>
            </div>
          </Container>
        </Section>
      </main>
    );
  }
}

export default ForgottenPw;



// WEBPACK FOOTER //
// ./src/pages/ForgottenPw.tsx